exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  padding-right: 6px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ContractsModule/SingleContractItemTransferDialogComponent/single-contract-item-transfer.dialog.component.scss
// module id = ../../../../../src/ContractsModule/SingleContractItemTransferDialogComponent/single-contract-item-transfer.dialog.component.scss
// module chunks = main